<template>
  <label class="create-itinerary-form-select">
    <span class="input-label-text" :class="{ 'input-label-text--required': required }">{{ label }}</span>
    <Multiselect
      v-model="vModel"
      id="itinerary-form-select"
      ref="multiselect"
      :allow-empty="false"
      label="title"
      :options="options"
      :placeholder="placeholder"
      :preselect-first="false"
      :preserve-search="true"
      :show-labels="false"
      track-by="id"
    >
      <template #noResult>No destinations found.</template>
    </Multiselect>

    <Transition name="fade-down">
      <span v-show="error" class="input-error">{{ error }}</span>
    </Transition>
  </label>
</template>

<script>
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';

export default {
  components: { Multiselect },
  props: {
    error: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      default: null,
    },
    required: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  computed: {
    vModel: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.create-itinerary-form-select {
  display: block;
  margin-bottom: 0;

  .input-label-text {
    display: block;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    color: vars.$c-dark-5b;

    &--required::after {
      content: '*';
      margin-left: 1px;
    }
  }

  .input-error {
    display: block;
    margin-top: 4px;
    font-size: 14px;
    line-height: normal;
    color: vars.$c-invalid;
    letter-spacing: 1px;
  }

  ::v-deep {
    .multiselect {
      color: vars.$c-dark-gray;

      &__select {
        height: 100%;
      }

      &__tags {
        padding-top: 12px;
        padding-bottom: 10px;
        padding-left: 16px;
        border: 1px solid vars.$c-gray-a2;
        border-radius: 1px;
      }

      &__placeholder,
      &__input,
      &__single {
        margin-bottom: 0;
      }

      &__placeholder,
      &__input {
        padding-top: 0;
        line-height: normal;
      }

      &__placeholder,
      &__input::placeholder {
        color: vars.$c-gray-a2;
      }

      &__placeholder {
        font-size: 16px;
        font-weight: 400;
      }

      &__input {
        margin-bottom: 1px;
      }

      &__input,
      &__single {
        padding-left: 0;
      }

      &__content-wrapper {
        border-top: none;
        border-bottom-left-radius: 1px;
        border-bottom-right-radius: 1px;
      }

      &__option--highlight,
      &__option--selected {
        background: vars.$c-f3f3f3;
        color: inherit;
      }

      &__option--selected {
        font-weight: 600;
      }
    }

    .multiselect--active .multiselect__tags,
    .multiselect__content-wrapper {
      border-color: vars.$c-gray-d8;
    }
  }
}
</style>
